import React, { useState } from 'react';
import styles from './introC.module.scss';
import commonIntroStyles from '@/components/intro/intro.module.css';
import { routesApp } from '@/constans/routes';
import { generatePath, useNavigate } from 'react-router-dom';
import { useAuth } from '@/store/useAuth';
import { callYaMetrika } from '@/utils/call-ya-metrika';
import { SignUpDesign, useSignUpDesign } from '@/store/useSignUpDesign';
import { useIntroRedirects } from '../useIntroRedirects';
import WebApp from '@twa-dev/sdk';
import { useVibration } from '@/store/useVibration';
import { LangSelector } from '@/components/lang-selector/lang-selector';
import { useTranslation } from 'react-i18next';

export const IntroC: React.FC = () => {
    const { user } = useAuth((state) => state);
    const navigate = useNavigate();

    const {
        design: signUpScreen,
        setDesign
    } =
        useSignUpDesign((state) => state)

    // rt15161: a/b test of sign up
    const generateSignUpPath = () => {
        let design: SignUpDesign =
            signUpScreen
        if (user) {
            setDesign(user?.registration_design)
            design = user?.registration_design
        }
        return generatePath(
            design === 'new_skip_steps' ?
                routesApp.registrationV4
            : design === 'new_photo_last' ?
                routesApp.registrationV3
            : design === 'new' ?
                routesApp.registrationV2
            :
                routesApp.registration,
            { stepNumer: '1' }
        );
    }

    useIntroRedirects('C')

    const { isVibrationEnabled } =
        useVibration(state => state);

    const registerClick = () => {
        callYaMetrika('clicked_registration_button');
        navigate(
            generateSignUpPath()
        );
        if (isVibrationEnabled) {
            WebApp
                .HapticFeedback
                .impactOccurred('medium');
            // pass for not android
            navigator.vibrate?.(10)
        }
    };

    const { t } = useTranslation();

    return (
        <>
            <section className={styles.intro}>
                <div className={styles['bottom-sheet']}>
                    <div className={styles['auth-promo']}>
                        <h2 className={styles['auth-promo__title']}>
                            {t('registration.intro_c_title')}
                        </h2>
                        <p className={styles['auth-promo__description']}>
                            {t('registration.intro_c_subtitle')}
                        </p>
                        <button className={styles['auth-promo__button']} onClick={registerClick}>
                            {t('registration.find_your_love')}
                        </button>
                        <small className={styles['auth-promo__footnote']}>
                            {t('registration.i_agree_with_terms.intro_c')}
                        </small>
                    </div>
                </div>
                <LangSelector className={commonIntroStyles.langSelector} />
            </section>
        </>
    );
};
